import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { StatusPageLayout } from '../components/layout/StatusPageLayout';
// @mcc-dev-preview:import
import { parseDevState, DEV_CARD_ID } from '../dev/devPreview';

// @mcc-dev-preview:start error-page-dev-state
const ERROR_PAGE_DEV_STATES = ['no-cardId', 'with-cardId'] as const;
// @mcc-dev-preview:end error-page-dev-state

const ErrorPage: React.FC = () => {
  const [errorMessage, setErrorMessage] = useState<string>('');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const cardIdFromUrl = searchParams.get('cardId');

  // @mcc-dev-preview:start error-page-dev-state
  const devState = parseDevState(searchParams, ERROR_PAGE_DEV_STATES);
  // @mcc-dev-preview:end error-page-dev-state

  useEffect(() => {
    // @mcc-dev-preview:start error-page-dev-state
    if (devState) {
      setErrorMessage(
        searchParams.get('errorMessage') ?? 'It appears that your card is not valid.'
      );
      return;
    }
    // @mcc-dev-preview:end error-page-dev-state

    const storedError = localStorage.getItem('errorMessage');
    if (storedError) {
      setErrorMessage(storedError);
      localStorage.removeItem('errorMessage');
    }
  }, [devState, searchParams]);

  let canTryAgain = Boolean(cardIdFromUrl) && cardIdFromUrl !== 'No card ID provided';
  // @mcc-dev-preview:start error-page-dev-state
  if (devState === 'with-cardId') {
    canTryAgain = true;
  } else if (devState === 'no-cardId') {
    canTryAgain = false;
  }
  // @mcc-dev-preview:end error-page-dev-state

  const handleTryAgain = () => {
    // @mcc-dev-preview:start error-page-dev-state
    if (devState) return;
    // @mcc-dev-preview:end error-page-dev-state
    if (!canTryAgain || !cardIdFromUrl) return;
    navigate(`/card/${cardIdFromUrl}`);
  };

  const handleContactUs = () => {
    let cardId = cardIdFromUrl || 'No card ID provided';
    // @mcc-dev-preview:start error-page-dev-state
    if (devState === 'with-cardId') {
      cardId = cardIdFromUrl ?? DEV_CARD_ID;
    } else if (devState === 'no-cardId') {
      cardId = 'No card ID provided';
    }
    // @mcc-dev-preview:end error-page-dev-state
    const subject = encodeURIComponent(`Card Error - Card ID: ${cardId}`);
    const body = encodeURIComponent(`Error Message: ${errorMessage || 'No specific error message provided'}`);
    window.location.href = `mailto:hello@mycryptocard.io?subject=${subject}&body=${body}`;
  };

  return (
    <StatusPageLayout
      variant="error"
      title="Oops!"
      body={errorMessage || 'It appears that your card is not valid.'}
      actions={
        <>
          {canTryAgain && (
            <button type="button" onClick={handleTryAgain} className="ev-btn-primary">
              Try again
            </button>
          )}
          <button type="button" onClick={handleContactUs} className="ev-btn-secondary">
            Contact us
          </button>
        </>
      }
    />
  );
};

export default ErrorPage;
